import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { restoreConsentFromStorage } from "./utils/googleAds";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Process from "./components/Process";
import CarForm from "./components/CarForm";
import ContactSection from "./components/ContactSection";
import Reviews from "./components/Reviews";
import Location from "./components/Location";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import StickyBadges from "./components/StickyBadges";
import MobileStickyBar from "./components/MobileStickyBar";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-tiktok-black pb-20 md:pb-0">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Process />
        <CarForm />
        <Reviews />
        <Location />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
      <StickyBadges />
      <MobileStickyBar />
      <CookieBanner />
    </div>
  );
};

function App() {
  // Stellt bei vorherigem Marketing-Consent das Tracking wieder her
  useEffect(() => {
    restoreConsentFromStorage();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
